<div class="px-10 py-1">
  <form *ngIf="form" [formGroup]="form" class="mb-10">
    <mat-form-field appearance="fill" class="w-100 mb-5">
      <mat-label>Code</mat-label>
      <input matInput formControlName="code" />
      <mat-error *ngIf="hasError('code', 'required')">{{
        getErrorMessage('Code', 'required')
      }}</mat-error>
      <mat-error *ngIf="hasError('code', 'duplicate')">{{
        getErrorMessage('Code', 'duplicate')
      }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-100 mb-5">
      <mat-label>Comment</mat-label>
      <textarea matInput formControlName="comment"></textarea>
      <mat-error *ngIf="hasError('comment', 'required')">{{
        getErrorMessage('comment', 'required')
      }}</mat-error>
    </mat-form-field>
    <div class="d-flex align-items-end justify-content-between">
      <div class="d-flex align-items-center">
        <button
          *ngIf="index"
          mat-raised-button
          class="btn btn-light mr-4"
          (click)="cancelQuickCommentUpdate($event)"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          class="btn btn-primary"
          (click)="addQuickComment($event)"
          [disabled]="mode === 'view'"
        >
          {{ index ? 'Update' : 'Add' }} Quick Comment
        </button>
      </div>
    </div>
  </form>
  <div class="border rounded p-4">
    <div *ngIf="!quickComments?.length" class="font-weight-bold text-center w-100">
      There is no quick comment added!
    </div>
    <ng-container *ngIf="quickComments?.length">
      <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
        <div class="col-2">Code</div>
        <div class="col-8">Comment</div>
        <div class="col-2">Actions</div>
      </div>
      <div
        *ngFor="let comment of quickComments; let idx = index"
        class="row border-bottom m-0 mb-2 p-2 w-100"
      >
        <div class="col-2">{{ comment.code }}</div>
        <div class="col-8">{{ comment.comment }}</div>
        <div class="col-2" *ngIf="mode !== 'view'">
          <button
            class="btn btn-icon btn-sm btn-light btn-hover-primary mr-1"
            [matTooltip]="'TABLE.UPDATE' | translate"
            (click)="updateQuickComment($event, idx)"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
              class="svg-icon svg-icon-md svg-icon-primary"
            ></span>
          </button>
          <button
            class="btn btn-icon btn-sm btn-light btn-hover-danger"
            [matTooltip]="'TABLE.DELETE' | translate"
            (click)="deleteQuickComment($event, idx)"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
              class="svg-icon svg-icon-md svg-icon-danger"
            ></span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
